import { createUseEntityList, createUseEntity } from 'api/base-hooks';
import { actionApi } from './action';
import { ActionListResponse, ActionResponse } from './action-types';

const SECTION = 'action';

export const useActionList = createUseEntityList<ActionListResponse>(SECTION, actionApi.getList);
export const useAction = createUseEntity<ActionResponse>(SECTION, actionApi.getItem);
